import {
  REFINANCE_TYPE,
  FIFTEEN_YEARS_FIXED,
  THIRTY_YEARS_FIXED,
  FIVE_ONE_ARM,
  TWENTY_YEARS_FIXED,
  TEN_YEARS_FIXED,
  SEVEN_ONE_ARM,
  TEN_ONE_ARM,
  THIRTY_YEARS_FIXED_JUMBO,
  FIFTEEN_YEARS_FIXED_JUMBO,
  PURCHASE_TYPE,
} from './constants'

export const propertyTypes = [
  { value: 'singleFamily', label: 'Single family' },
  { value: 'townhouse', label: 'Townhouse' },
  { value: 'condo', label: 'Condo' },
  { value: 'manufacturedHome', label: 'Manufactured home' },
  { value: 'twoUnits', label: '2-unit' },
  { value: 'threeUnits', label: '3-unit' },
  { value: 'fourUnits', label: '4-unit' },
]

export const occupancyTypes = [
  { value: 'primaryResidence', label: 'Primary residence' },
  { value: 'secondHome', label: 'Second home' },
  { value: 'investmentProperty', label: 'Investment property' },
]

export const ficoTypes = [
  { value: 'excellent', label: 'Excellent (740+)' },
  { value: 'veryGood', label: 'Very good (700-739)' },
  { value: 'good', label: 'Good (660-699)' },
  { value: 'fair', label: 'Fair (660 or below)' },
]

export const sortingDropdown = [
  { value: 'monthlyPayment', label: 'Mo. payment' },
  { value: 'apr', label: 'APR' },
  { value: 'fees', label: 'Fees' },
  { value: 'rate', label: 'Interest rate' },
]

export const sortingDropdownMortgageCombined = [
  { value: 'monthlyPayment', label: 'Mo. payment' },
  { value: 'apr', label: 'APR' },
  { value: 'closingCost', label: 'Closing costs' },
  { value: 'rate', label: 'Interest rate' },
]

export const lendersBestSortingDropdown = [
  { value: 'monthlyPayment', label: `Lenders' Best Mo. payment` },
  { value: 'apr', label: `Lenders' Best APR` },
  { value: 'closingCost', label: `Lenders' Best Closing costs` },
  { value: 'rate', label: `Lenders' Best Interest rate` },
]

export const termsHeaderLabel = {
  [THIRTY_YEARS_FIXED_JUMBO]: '30-year fixed jumbo',
  [FIFTEEN_YEARS_FIXED_JUMBO]: '15-year fixed jumbo',
  [THIRTY_YEARS_FIXED]: '30-year fixed',
  [FIFTEEN_YEARS_FIXED]: '15-year fixed',
  [TWENTY_YEARS_FIXED]: '20-year fixed',
  [TEN_YEARS_FIXED]: '10-year fixed',
  [FIVE_ONE_ARM]: '5/1 adjustable',
  [SEVEN_ONE_ARM]: '7/1 adjustable',
  [TEN_ONE_ARM]: '10/1 adjustable',
}

export const termsHeaderLabelShortVersion = {
  ...termsHeaderLabel,
  [THIRTY_YEARS_FIXED_JUMBO]: '30-yr fixed jumbo',
  [FIFTEEN_YEARS_FIXED_JUMBO]: '15-yr fixed jumbo',
  [THIRTY_YEARS_FIXED]: '30-yr fixed',
  [FIFTEEN_YEARS_FIXED]: '15-yr fixed',
  [TWENTY_YEARS_FIXED]: '20-yr fixed',
  [TEN_YEARS_FIXED]: '10-yr fixed',
}

export const scoresMap = {
  excellent: '740+',
  veryGood: '700-739',
  good: '660-699',
  fair: '660 or below',
}

export const verticalOptions = [
  { value: PURCHASE_TYPE, label: 'Purchase' },
  { value: REFINANCE_TYPE, label: 'Refinance' },
]
export const switchOptions = {
  left: { value: PURCHASE_TYPE, label: 'Purchase' },
  right: { value: REFINANCE_TYPE, label: 'Refinance' },
}
export const filterTypeList = { Conventional: 'Conventional', FHA: 'FHA' }
